/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Runtime used for the video meeting portion of an appointment.
 */
export type VideoMeetingProvider = (typeof VideoMeetingProvider)[keyof typeof VideoMeetingProvider];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VideoMeetingProvider = {
  teams: 'teams',
  livekit: 'livekit',
  none: 'none',
} as const;
